import { createContext } from "react";

export interface ParticipantDetails {
  id: string;
  name: string;
  phone: string;
  email?: string;
  isAdmin?: boolean;
  groups?: string[];
  joinedAt?: Date;
}

export interface EventData {
  id: string;
  title: string;
  description: string;
  titleKey?: string; // Optional translation key for title
  descriptionKey?: string; // Optional translation key for description
  date: Date;
  time: string;
  location: string;
  group: string;
  groupKey?: string; // Optional translation key for group
  groupColor?: string; // Color hex code from the group table
  level?: string; // Skill level (beginner, intermediate, advanced, etc.)
  participants: string[];
  participantDetails?: ParticipantDetails[]; // Detailed participant info for tournaments
  maxParticipants: number;
  type: string;
  notes?: string;
  waitingList?: string[];
  waitingListDetails?: ParticipantDetails[]; // Detailed waiting list info
  customSignupHours?: number; // Override for default signup window
  recurrencePattern?: string;
  recurrenceEndDate?: Date;
  parentEventId?: string;
  isRecurringMaster?: boolean;
}

export interface EventContextValue {
  events: EventData[];
  signUp: (id: string, userId: string) => void;
  cancel: (id: string, userId: string) => void;
  joinWaitingList: (id: string, userId: string) => void;
  leaveWaitingList: (id: string, userId: string) => void;
  removeParticipant: (id: string, participantId: string) => void;
  refreshEvents: () => Promise<void>;
}

export const EventContext = createContext<EventContextValue | null>(null);
